export enum GroupErrors {
  NoGroupInfoFound = "Group info not found",
}
